<template>
  <div class="registrationBox">

    <div class="premiseBox">
      <div class="msgBox">
        <img class="premiseTitleImg" src="@/assets/img/awardsAct2/premiseTitleImg.png" alt="">
        <p class="msg">
          自快应用上线以来，吸引并获得大量开发者支持，涌现很多优秀快应用产品；联盟大力支持和鼓励开发者的创新精神，并对于优秀的快应用颁发风锐奖;欢迎大家踊跃报名！
        </p>
      </div>           
    </div>
    
    <div class="prizeBox">
      <img class="appPrizeTitleImg" width="100%" src="@/assets/img/awardsAct2/appPrizeTitleImg.png" alt="" >
        <div class="appPrizeBox">
          <div class="titleImg">
            <img src="@/assets/img/awardsAct2/appTitle.png" alt="">
          </div>
          <ul class="prizeList appPrizeList">
            <li class="item appItem" v-for="(item,index) in awardsActAppList" :key="index">
              <img class="appPrizeImg" :src="item.icon" alt="">
              <p class="msg">{{item.name}}</p>
              <a class="btn" v-if="awardsActInfo['status']==2" href="javascript:;" @click="alertBox">立即报名</a>
            </li>
          </ul>
        </div>
        <div class="appPrizeBox">
          <div class="titleImg">
            <img src="@/assets/img/awardsAct2/companyTitle.png" alt="">
          </div>
          <ul class="prizeList appPrizeList">
            <li class="item appItem" v-for="(item,index) in awardsActcompanyList" :key="index">
              <img class="appPrizeImg" :src="item.icon" alt="">
              <p class="msg">{{item.name}}</p>
              <a class="btn" v-if="awardsActInfo['status']==2" href="javascript:;" @click="alertBox">立即报名</a>
            </li>
          </ul>
        </div>
    </div>

    <div class="judgesBox">
      <img class="judgesTitleImg" src="@/assets/img/awardsAct2/judgesTitleImg.png" alt="">
      <img class="judgesList" src="@/assets/img/awardsAct2/judgesList.png" alt="">
    </div>

    <div class="detailsBox">
      <img class="titleDataImg" src="@/assets/img/awardsAct2/titleDataImg.png" alt="">
      <ul class="timelineBox">
        <li class="subTitleBox">
            <div class="subtitle subtitle1">开发者报名</div>
            <div class="subtitle">官方评选</div>
            <div class="subtitle">奖项颁布</div>
          </li>
          <li class="dateBox">
            <div class="date">{{awardsActInfo['applyDate'] | dateMMDD}}</div>
            <div class="date">{{awardsActInfo['juryDate'] | dateMMDD}}</div>
            <div class="date">
              <span  v-if="awardsActInfo['awardDate']==0">敬请期待</span>
              <span v-else>{{awardsActInfo['awardDate'] | dateMMDD}}&emsp;</span>
            </div>
            <div class="date">
              <span  v-if="awardsActInfo['giveAwardDate']==0">敬请期待</span>
              <span v-else>{{awardsActInfo['giveAwardDate'] | dateMMDD}}</span> 
            </div>
          </li>
      </ul>
    </div>

    <div class="declareBox">
      <img class="declareTItleImg" src="@/assets/img/awardsAct2/declareTItleImg.png" alt="">
      <ul class="declareList">
        <li class="item">
          <img src="@/assets/img/awardsAct2/triangle.png" alt="">
          登录快应用官网报名
          <ul>
            <li class="subItem"><strong>·</strong>&nbsp;https://www.aiservhub.com/</li>
          </ul>
        </li>
        <li class="item">
          <img src="@/assets/img/awardsAct2/triangle.png" alt="">
          快应用报名
          <ul>
            <li class="subItem"><strong>·</strong>&nbsp;登录账号后选择相应的奖励，点击“立即报名”；</li>
            <li class="subItem"><strong>·</strong>&nbsp;根据奖项要求选择快应用；</li>
            <li class="subItem"><strong>·</strong>&nbsp;根据报名要求填写报名信息提交即可；</li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="mattersBox">
      <img class="mattersTitleImg" src="@/assets/img/awardsAct2/mattersTitleImg.png" alt="">
      <ul class="mattersList">
        <li><img src="@/assets/img/awardsAct2/triangle2.png" alt="">请合理选择、填写参报内容，本次报赛无须提交纸质版说明材料；</li>
        <li><img src="@/assets/img/awardsAct2/triangle2.png" alt="">同款快应用申报的奖项最多不超过2类，最终获奖不超过一项；</li>
        <li><img src="@/assets/img/awardsAct2/triangle2.png" alt="">同一公司获奖数量最多不超过2个；</li>
        <li><img src="@/assets/img/awardsAct2/triangle2.png" alt="">活动解释权归快应用联盟所有；</li>
      </ul>
    </div>

  </div>
</template>
<script>
export default {
  created() {
    this.queryAwardsActDetail();
    this.queryAwardsActAllType();
  },
  data() {
    return {
      newDate:new Date().getTime(),
      awardsActInfo:{},//风锐奖详情
      awardsActAppList:[],//快应用奖项list
      awardsActcompanyList:[],//企业篇奖项
    };
  },
  methods: { 
    alertBox(){
      this.$dialog.alert({
        message: '请使用电脑访问此页面报名',
        confirmButtonText:'好的',
        confirmButtonColor:'#2537B5',
      }).then(() => {
        // on close
      });
    },   
    //获取风锐奖详情
    queryAwardsActDetail(){
      this.$apis.awardsActServer.queryAwardsActDetail({
        id:'2',
      }).then(res=>{
        if (res["code"] == 0) {
          this.awardsActInfo = res["data"];
        } else {
          this.$dialog.alert({
            message: res['msg'],
            confirmButtonColor:'#2537B5',
          });
        }
      })
    },
    // 获取奖项列表
    queryAwardsActAllType() {
      singleAwardsAct.queryAwardsActAllType({
        "id": '2', //风锐奖id
        "type": '',// 类型：1应用；2游戏
      }).then(res => {
        if (res["code"] == 0) {
          for(let i =0; i<res["data"].length;i++){  
            let type = res['data'][i]['type'];
            if(type=='4' || type=='8'){
              this.awardsActcompanyList.push(res['data'][i]);
            }else{
              this.awardsActAppList.push(res['data'][i]);
            }
          }  
        } 
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.registrationBox{
  .premiseBox{
    .msgBox{
      height: 372px;
      padding: 121px 46px 0 49px;
      background: url(~@/assets/img/awardsAct2/premiseBj.png) no-repeat 70px 24px;
      background-size:100% 100%;
      margin-bottom: 29px;
      .premiseTitleImg{
        display: block;
        width: 156px;
        height: 61px;
        margin: 0 auto 29px;

      }
      .msg{             
        color: #666666;
        font-size: 24px;
        line-height: 46px;
        text-align: center;
      }
    }
  }
  .prizeBox{
    background: url(~@/assets/img/awardsAct2/prizeBoxBj.png) no-repeat top center;
    background-size:750px 200px;
    padding-top: 33px;
    margin: 0 22px 42px;
    .appPrizeTitleImg{
      display: block;
      margin: auto;
      width: 125px;
      height: 61px;
      margin-bottom: 25px;
    }
    .appPrizeBox{
      background: #FFFFFF;
      box-shadow: 4px 2px 10px 0px rgba(168, 168, 224, 0.3);
      border-radius: 10px;
      margin-bottom: 20px;
      overflow: hidden;
      .titleImg{
        margin-top: 14px;
        width: 140px;
        height: 48px;
        margin-bottom: 57px;
      }
    }
    .prizeList{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;
      .item{    
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        align-items: center;
        padding-bottom: 70px;
        background: #FFF;
        .appPrizeImg{
          width: 145px;
          height: 145px;
          margin-bottom: 20px;
        }
        .msg{
          width: 100%;
          margin-bottom: 19px;
          font-size: 20px;
          font-weight: bold;
          color: #333333;
          text-align: center;
        }
        .btn{
          width: 146px;
          height: 43px;
          text-align: center;
          line-height: 45px;
          border: 1px solid #0E4FF2;
          border-radius: 21px;
          color:#0E4FF2 ;
          background: #fff;
        }
      }
    }
    .appPrizeList{
      margin: 0 auto;
      .appItem{
        width: 150px;
        // height: 260px;
      }
    }
  }
  .judgesBox{
    width: 100%;
    height: 662px;
    background: url(~@/assets/img/awardsAct2/judgesBoxBj.png) no-repeat top center;
    background-size:100% 100%;
    overflow: hidden;
    .judgesTitleImg{
      display: block;
      margin: 64px auto 49px;
      width: 125px;
      height: 61px;
    }
    .judgesList{
      display: block;
      margin: 0 auto;
      width: 690px;
      height: 420px;
    }
  }
  .detailsBox{
    height: 400px;
    .titleDataImg{
      display: block;
      width: 123px;
      height: 65px;
      margin: 56px auto 70px;
    }
    .timelineBox{
      width: 659px;
      height: auto;
      margin: 0 auto;
      background: url(~@/assets/img/awardsAct2/timeline.png) no-repeat top center;
      background-size:656px 69px ;
      .subTitleBox{
        width: 100%;
        padding-right: 50px;
        display: flex;
        justify-content: space-around;
        .subtitle{
          color: #0065ff;
        }
        .subtitle1{
          margin-left:10px ;
        }
      }
      .dateBox{
        width: 660px;
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        .undete{
          margin-right: 50px;
        }
        .undete2{
          margin-right: 20px;
        }
      }
    }
  }
  .declareBox{
    height: 680px;  
    background: #0065FF;
    overflow: hidden;
    .declareTItleImg{
      display: block;
      width: 124px;
      height: 62px;
      margin: 56px auto 65px;
    }
    .declareList{
      margin-left:53px;
      .item{
        font-weight: bold;
        font-size: 33px;
        color: #fff;
        margin-bottom: 69px;
        img{
          width: 25px;
          height: 24px;
          margin-right: 11px;
        }
        .subItem{
          font-weight: normal;
          font-size: 25px;
          margin-top: 30px;
          margin-left: 40px;
        }
      }
    }
  }
  .mattersBox{
    height: 660px;
    background: #22221E;
    overflow: hidden;
    .mattersTitleImg{
      display: block;
      width: 184px;
      height: 62px;
      margin: 54px auto 65px;
    }
    .mattersList{
      margin: 0 48px;
      color: #fff;
      font-size: 24px;
      li{
        line-height: 60px;
        img{
          width: 23px;
          height: 26px;
          margin-right: 12px;
        }
      }
    }
  }
}
</style>
